import { render, staticRenderFns } from "./yi-coupon.vue?vue&type=template&id=8c8c2ad2&scoped=true&"
import script from "./yi-coupon.vue?vue&type=script&lang=js&"
export * from "./yi-coupon.vue?vue&type=script&lang=js&"
import style0 from "./yi-coupon.vue?vue&type=style&index=0&id=8c8c2ad2&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8c8c2ad2",
  null
  
)

component.options.__file = "src/components/yi-coupon/yi-coupon.vue"
export default component.exports